import { useMemo, useState } from 'react'
import { useThreadsSectionPreviewLimit } from './useThreadsSectionPreviewLimit.js'

export function useThreadsSectionPreview(filteredThreads) {
  const [viewAllOpen, setViewAllOpen] = useState(false)
  const previewLimit = useThreadsSectionPreviewLimit()

  const hasMoreThanPreview = filteredThreads.length > previewLimit

  const visibleThreads = useMemo(() => {
    if (!hasMoreThanPreview) return filteredThreads
    return filteredThreads.slice(0, previewLimit)
  }, [filteredThreads, hasMoreThanPreview, previewLimit])

  const openViewAll = () => setViewAllOpen(true)
  const closeViewAll = () => setViewAllOpen(false)

  return {
    visibleThreads,
    viewAllOpen,
    hasMoreThanPreview,
    openViewAll,
    closeViewAll,
  }
}
